export const EXPORT_END_HOLD_DURATION_MS = 1_000

export interface ExportFrameTiming {
  exportDurationMs: number
  timelineElapsedMs: number
  effectsElapsedMs: number
  isEndHold: boolean
}

export function resolveExportFrameTiming(
  frameNumber: number,
  fps: number,
  timelineDurationMs: number,
  endHoldDurationMs = EXPORT_END_HOLD_DURATION_MS,
): ExportFrameTiming {
  const exportDurationMs = timelineDurationMs + endHoldDurationMs
  const effectsElapsedMs = Math.min(exportDurationMs, frameNumber * (1_000 / fps))
  return {
    exportDurationMs,
    timelineElapsedMs: Math.min(timelineDurationMs, effectsElapsedMs),
    effectsElapsedMs,
    isEndHold: effectsElapsedMs > timelineDurationMs,
  }
}
